import { BooleanField, NumberField, StringField } from '@mng/model';
import { fZKontoValidation } from '../antrag/angebot/zahlungsart/zahlungsart.validation';

export function createFzKontoKontoField(): StringField {
  return new StringField('konto', 'Konto')
    .withValidation(fZKontoValidation)
    .withRequired()
    .withRemoveDataWhenNotRelevant();
}

export function createFzKontoKontoNameField(): StringField {
  return new StringField('kontoName', 'Konto-Name').withRemoveDataWhenNotRelevant();
}

export function createFzKontoExklusivAbberNrField(): StringField {
  return new NumberField('exklusivAbberNr', 'Exclusiv-Abbers');
}

export function createFzKontoVerrechnungsartField(): StringField {
  return new StringField('verrechnungsart', 'Verrechnungsart').withRemoveDataWhenNotRelevant();
}

export function createFzKontoBezeichnungField(): StringField {
  return new StringField('bezeichnung', 'Bezeichnung').withRemoveDataWhenNotRelevant();
}

export function createFzKontoHinweisField(): StringField {
  return new StringField('hinweis', 'Hinweis').withRemoveDataWhenNotRelevant();
}

export function createFzKontoPersonalNummer(): StringField {
  return new StringField('personalNummer', 'PersonalNummer').withReadOnly();
}

export function createFzKontoGiltVonField(): StringField {
  return new StringField('giltVon', 'Gültigkeitsbeginn').withRemoveDataWhenNotRelevant().withReadOnly();
}

export function createFzKontoGiltBisField(): StringField {
  return new StringField('giltBis', 'Gültigkeitsende').withRemoveDataWhenNotRelevant().withReadOnly();
}

export function createFzKontoPersonalNummerRegexField(): StringField {
  return new StringField('personalNummerRegex', 'Personalnummer Regex').withRemoveDataWhenNotRelevant();
}

export function createFzKontoPersonalExplanationField(): StringField {
  return new StringField('personalNummerExplanation', 'Personalnummer Erklärung').withRemoveDataWhenNotRelevant();
}

export function createFzKontoDienststelleRequiredField(): BooleanField {
  return new BooleanField('dienststelleRequired', 'Dienststelle erforderlich')
    .withRemoveDataWhenNotRelevant()
    .withReadOnly();
}

export function createFzPersNrErforderlichField(): BooleanField {
  return new BooleanField('persNrErforderlich', 'Personal Nummer erforderlich')
    .withRemoveDataWhenNotRelevant()
    .withReadOnly();
}
